module.exports = __webpack_public_path__ + "static/media/naruxforallLogo.39721d24.png";